import { OrderBy } from '@fleet-beat/core';

export interface GetManyDto {
  include?: string;
  search?: string;
  product?: string;
  boundingBox?: string;
  rsql?: string;
  orderBy?: string;
  order?: OrderBy;
  statuses?: string;
  createdAt?: string;
  expirationDate?: string;
  limit?: number;
  lastIndexKey?: number;
  lastOrderKey?: string;
  isActive?: boolean;
  forUserId?: string;
  tenantIds?: string;
}
